import { CatHeading } from '@blocks-react/components/Heading';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { Conditional } from '../conditional';
import { FC } from 'react';

export type StoreServicesOfferedProps = {
  title: string;
  serviceOffered: string[];
  isStoreLocationOptimizationFlag: boolean;
};

export const StoreServicesOffered: FC<StoreServicesOfferedProps> = ({
  title,
  serviceOffered = [],
  isStoreLocationOptimizationFlag
}) => {
  return (
    <Conditional test={!!serviceOffered.length}>
      <div className="my-3">
        <div className={isStoreLocationOptimizationFlag ? 'mb-3' : ''}>
          <CatHeading level="h2" variant={'title-sm'}>
            {title}
          </CatHeading>
        </div>

        <Conditional
          test={isStoreLocationOptimizationFlag}
          fallback={
            <CatTextPassage size="sm">
              {serviceOffered.join(', ')}
            </CatTextPassage>
          }
        >
          <CatTextPassage>{serviceOffered.join(', ')}</CatTextPassage>
        </Conditional>
      </div>
    </Conditional>
  );
};
